/** Recognise only the canonical document workspace for this authenticated agency.
 * Resource access is revalidated by the API; never navigate to notification-supplied URLs.
 */
export function agencyDocumentNotificationRoute(
  data: unknown,
  ownAgencyId: unknown,
): string | null {
  const validId = (value: unknown): string | null => {
    if (typeof value !== "string" && typeof value !== "number") return null;
    const text = String(value);
    return /^[1-9]\d*$/.test(text) && Number.isSafeInteger(Number(text))
      ? text
      : null;
  };
  if (!data || typeof data !== "object" || Array.isArray(data)) return null;
  const target = data as Record<string, unknown>;
  if (
    target.entityType !== "agency_document" ||
    Object.keys(target).some(
      (key) => !["entityType", "agencyId", "documentId", "url"].includes(key),
    )
  )
    return null;
  const agency = validId(target.agencyId),
    document = validId(target.documentId),
    ownAgency = validId(ownAgencyId);
  if (
    !agency ||
    !document ||
    !ownAgency ||
    agency !== ownAgency ||
    target.url !== "/profile/documents"
  )
    return null;
  return "/profile/documents";
}
